import type { FC, PropsWithChildren } from "react";
import ContextComponents from "../../context/contexts";

const TopLevelComponent: FC<PropsWithChildren> = ({ children }) => children;

const NestedContexts = ContextComponents.reduce(
	(WrappingComponent, CurrentComponent) =>
		function NestedContext(props: PropsWithChildren) {
			return (
				<WrappingComponent>
					<CurrentComponent {...props} />
				</WrappingComponent>
			);
		},
	TopLevelComponent,
);

const ContextWrapper: FC<PropsWithChildren> = ({ children }) => {
	return <NestedContexts>{children}</NestedContexts>;
};

export default ContextWrapper;
